
<template>
  <div class="classify" :class="{ isIosx: isIosx }">
    <van-sticky>
      <div class="classifyNav">
        <div class="navLeft" @click="search()">
          <img src="./../../assets/school/seach1.png" />
          <span>请输入想要搜索的课程</span>
        </div>
        <div class="navRight">
          <img
            class="sf"
            v-if="isToken"
            @click="share()"
            src="./../../assets/school/sfh.png"
          />
        </div>
      </div>
    </van-sticky>
    <!--  -->
    <div class="content" :class="{ classifyNoApp: !isToken }" v-if="loaded">
      <van-tree-select
        height="100%"
        :items="navList"
        :main-active-index.sync="active"
        @click-nav="clickNav"
      >
        <template #content>
          <div class="content_content">
            <div v-for="(item, index) in contentList" :key="index">
              <h3>
                <span @click="toSecondClassify(item.title, item.children, -1)">
                  <img
                    v-if="item.img"
                    :src="item.img"
                    style="width: 16px; height: 16px"
                  />
                  <span style="margin-left: 4px">{{ item.title }}</span>
                </span>
                <img
                  src="./../../assets/school/right.png"
                  @click="toSecondClassify(item.title, item.children, -1)"
                />
              </h3>
              <div>
                <span
                  v-for="(i, index) in item.children"
                  :key="index"
                  @click="toSecondClassify(item.title, item.children, i.id)"
                  >{{ i.title }}</span
                >
                <span
                  v-if="item.more"
                  @click="
                    item.children = item.childrenMore;
                    item.more = false;
                  "
                  >更多
                  <img src="./../../assets/school/xia1.png" />
                </span>
                <span
                  v-if="item.children.length > 8 && !item.more"
                  @click="
                    item.children = item.childrenPack;
                    item.more = true;
                  "
                  >收起
                  <img src="./../../assets/school/shang1.png" />
                </span>
              </div>
            </div>
          </div>
        </template>
      </van-tree-select>
    </div>
    <div v-else class="loading">
      <img src="./../../assets/school/loading.gif" />
      <p>加载中</p>
    </div>
    <SfBtm :mobile="mobile" v-if="!isToken && mobile"></SfBtm>
    <span class="shareTip" v-if="!isToken && mobile"
      >{{ mobile.substring(0, 3) + "****" + mobile.substring(7) }}的分享</span
    >
  </div>
</template>

<script>
import SfBtm from "./components/sfBtm.vue";
export default {
  data() {
    return {
      isIosx: false,
      loaded: false,
      active: 0,
      dataList: [],
      navList: [],
      contentList: [],
      isToken: false,
      mobile: "",
    };
  },
  components: { SfBtm },
  mounted() {
    this.isIosx = this.isIphoneX();
    if (JSON.parse(sessionStorage.getItem("token"))) {
      this.isToken = true;
      this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
      this.getMobile();
    } else {
      this.isToken = false;
      if (this.$route.query.mobile) {
        this.mobile = this.$route.query.mobile;
        sessionStorage.setItem("mobile", this.mobile);
      }
    }
    this.getData();
  },
  methods: {
    // 获取分类
    getData() {
      this.$api.get("school/index/api_cate_gory/trees").then((res) => {
        this.dataList = res;
        this.loaded = true;
        this.dataList.forEach((item) => {
          // 一级导航菜单
          this.navList.push({
            text: item.title,
          });
        });
        // 二三级菜单
        this.getTSdata(this.dataList[this.active]);
      });
    },
    // 获取二三级菜单
    getTSdata(data) {
      let leave2 = [];
      if (data && data.children && data.children.length > 0) {
        data.children.forEach((item) => {
          let childrenData = [];
          let childrenPackData = [];
          let childrenMoreData = [];
          if (item.children && item.children.length > 0) {
            item.children.forEach((i, index) => {
              if (index < 8) {
                childrenData.push({
                  title: i.title,
                  id: i.id,
                });
                childrenPackData.push({
                  title: i.title,
                  id: i.id,
                });
                childrenMoreData.push({
                  title: i.title,
                  id: i.id,
                });
              } else {
                childrenMoreData.push({
                  title: i.title,
                  id: i.id,
                });
              }
            });
          }
          leave2.push({
            title: item.title,
            children: childrenData,
            childrenPack: childrenPackData,
            childrenMore: childrenMoreData,
            more: childrenMoreData.length > 8 ? true : false,
            img: item.image,
          });
        });
      }
      this.contentList = leave2;
    },
    clickNav(index) {
      this.getTSdata(this.dataList[this.active]);
    },
    // 跳转二级分类
    toSecondClassify(title, data, id) {
      // return
      let activeId = -2;
      if (id == -1) {
        if (data.length == 0) {
          activeId = -1;
        } else {
          activeId = -2;
        }
      } else {
        activeId = id;
      }
      this.$router.push({
        path: "/school/secondClassify",
        query: {
          title: title,
          navList: JSON.stringify(data),
          activeId: activeId,
        },
      });
    },
    // 搜索
    search() {
      this.$router.push({
        path: "/school/search",
      });
    },
    // 获取会员手机号
    getMobile() {
      this.$api.get("school/member/share/mobile").then((res) => {
        this.mobile = res.mobile;
      });
    },
    // 分享
    share() {
      // 获取会员手机号
      this.$api.post("school/index/business/school/get/share").then((res) => {
        let title = res.small_title;
        let bigTitle = res.big_title;
        let thumb = res.image;
        let url = `${window.location.protocol}//${window.location.host}/school/classify?mobile=${this.mobile}`;
        let paramAndroid = [bigTitle, title, url, thumb];
        let paramIos = [title, bigTitle, url, thumb];
        this.params(paramIos, JSON.stringify(paramAndroid), "toShare");
      });
    },
  },
};
</script>

<style scoped>
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.loading img {
  width: 80px;
  height: 80px;
  margin: 200px 0 0;
}
.loading p {
  font-size: 12px;
  color: #9ca1ad;
}

.classify {
  height: 100%;
  background-color: #ffffff;
}
.classifyNav {
  color: #404247;
  height: 22px;
  padding-top: 38px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 11px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.classifyNav .navLeft {
  flex: 1;
  height: 34px;
  background: #f7f8fc;
  border-radius: 16px;
  margin-right: 13px;
  display: flex;
  align-items: center;
}
.classifyNav .navLeft img {
  margin: 0 6px 0 18px;
  width: 16px;
  height: 16px;
}
.classifyNav .navLeft span {
  color: #cacde0;
  font-size: 15px;
}
.classifyNav .navRight .sf {
  width: 40px;
  height: 31px;
}
/* content */
.content {
  margin-top: 11px;
  height: calc(100% - 65px);
}
.classifyNoApp {
  padding-bottom: 80px;
}
/* 右侧内容样式 */
.van-tree-select__content {
  margin: 0 16px;
  /* background-color: #f5f5f5; */
}
.content_content h3 {
  font-size: 14px;
  margin: 16px 0;
  color: #404247;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.content_content h3 > span {
  display: flex;
  align-items: center;
}
.content_content h3 img {
  width: 12px;
  height: 12px;
}
.content_content > div > div {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.content_content > div > div:after {
  content: "";
  width: 31%;
}
.content_content > div > div > span {
  width: 31%;
  height: 48px;
  line-height: 48px;
  display: block;
  background-color: #f7f8fc;
  /* text-align: center; */
  margin-bottom: 8px;
  border-radius: 6px;
  color: #6e727a;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.content_content > div > div > span img {
  width: 12px;
  height: 12px;
  margin-left: 2px;
}
/* 左侧导航栏样式 */
.van-tree-select__nav {
  width: 100px;
  flex: none;
  background: #f7f8fc;
  border-radius: 6px 6px 0px 0px;
}
.van-sidebar-item {
  height: 66px;
  line-height: 66px;
  padding: 0;
  display: flex;
  justify-content: center;
  background-color: #f7f8fc;
  color: #6e727a;
}
.van-sidebar-item--select,
.van-sidebar-item--select:active {
  background-color: #ffffff;
  color: #404247;
  font-weight: 700;
}
.van-sidebar-item--select::before {
  width: 4px;
  height: 16px;
  background: linear-gradient(180deg, #86b4fc 0%, #4e7df7 100%);
  border-radius: 2px;
}

.isIosx .classifyNav {
  padding-top: 49px;
}
.shareTip {
  position: fixed;
  top: 7px;
  right: 0;
  padding: 8px 16px 8px 24px;
  background: rgba(14, 14, 14, 0.36);
  border-radius: 18px 0px 0px 18px;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  z-index: 999;
}
</style>